import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_API_CLIENTS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/public-api-clients',
        iconClass: 'fas fa-plug',
        name: '::Menu:PublicApiClients',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.PublicApiClients',
        order: 13,
      },
    ]);
  };
}
